import React, { useEffect, useState } from 'react'
import { firestore, addDoc, collection, getDocFromServer, deleteDoc } from '~providers/firebase'
import DiagnosticsResult from '../DiagnosticsResult'
import { Status } from '../types'

export default function FirebaseFirestoreChecker(): React.JSX.Element {
  const [status, setStatus] = useState<Status>('inprogress')
  const [error, setError] = useState<Error>()

  useEffect(() => {
    let cancel = false

    async function ping() {
      try {
        // Create
        const ref = await addDoc(collection(firestore, 'diagnostics'), {
          ping: 'pong',
        })

        try {
          // Get
          const doc = await getDocFromServer(ref)
          if (JSON.stringify({ ping: 'pong' }) !== JSON.stringify(doc.data())) {
            throw new Error(`Unexpected response [doc=${JSON.stringify(doc.data())}]`)
          }
        } finally {
          // Delete
          await deleteDoc(ref)
        }

        if (!cancel) {
          setStatus('success')
          setError(undefined)
        }
      } catch (error) {
        if (!cancel) {
          setStatus('failed')
          setError(error)
        }
      }
    }

    ping()

    return () => {
      cancel = true
    }
  }, [])

  return (
    <DiagnosticsResult
      title="Firebase Firestore"
      description="Read/write/delete operation on database"
      status={status}
      error={error}
    />
  )
}
